<template>
  <div id="swiper-container">
    <img class="time" src="./img/time.png" alt="">
    <div class="line-container" :style="{ left: `${currentLeft * 100}%` }">
      <div class="line"></div>
    </div>
    <swiper ref="mySwiper" :options="swiperOption">
      <swiper-slide
        v-for="(item, i1) in newAreas"
        :key="i1"
        class="swiper-slide"
      >
        <meeting-item :item="item" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import meetingItem from "./components/meetingItem";
import moment from "moment";

// time bar color
export const TIMEBAR_COLORS = {
  // 过去
  past: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  // 现在正在进行
  now: {
    backgroundColor: "#FBE947",
  },
  // 未来
  future: {
    backgroundColor: "#FBE947",
  },
};

export const TIME_SETTING = {
  range: ["00:00", "24:00"], // 范围
  interval: "1", // 间隔（mins）
};

export default {
  name: "MeetingStatusBoard",
  components: {
    meetingItem,
  },
  props: {
    areas: {
      type: Array,
      default: () => [],
    },
    currentTime: {
      type: Object,
      default: () => [],
    },
  },
  data: function () {
    return {
      swiperOption: {
        //显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false,
        },
        //开启循环模式
        loop: true,
        // 循环方向
        direction: "vertical",
        slidesPerView: 5,
        slidesPerGroup: 5,
        loopFillGroupWithBlank: true,
        spaceBetween: 100,
        speed: 800,
        height: 450,
        // width:200
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    // 总个数
    blockCount() {
      let end = moment(
        `${moment().format("YYYY-MM-DD")} ${TIME_SETTING.range[1]}`
      ).unix();
      return this.handle_left(end);
    },
    // 计算出每块的宽度
    eachWidth() {
      return 1 / this.blockCount;
    },
    // 每块的left值的数组
    eachLeft() {
      let leftList = [];
      let step = 0; // 步长

      for (let i = 0; i < this.blockCount; i++) {
        leftList.push(step);
        step += this.eachWidth;
      }

      return leftList;
    },
    // 当前时间在哪个块上
    currentCount() {
      let currentTime = this.currentTime.unix;
      return this.handle_left(currentTime);
    },
    // 当前时间的left值
    currentLeft() {
      return this.eachLeft[this.currentCount -1];
    },
    newAreas() {
      return this.areas.map((m) => {
        if (!!m.reservations && m.reservations.length > 0) {
          m.reservations = m.reservations.map((n) => {
            n.start_block = this.eachLeft[this.handle_left(n.start_at) - 1];
            n.end_block = this.eachLeft[this.handle_left(n.real_end_at) - 1];
            n.bgColor = "";
            if (
              this.currentTime.unix > n.start_at &&
              this.currentTime.unix <= n.real_end_at
            ) {
              n.bgColor = TIMEBAR_COLORS.now.backgroundColor;
            } else if (this.currentTime.unix <= n.start_at) {
              n.bgColor = TIMEBAR_COLORS.future.backgroundColor;
            } else {
              n.bgColor = TIMEBAR_COLORS.past.backgroundColor;
            }
            return n;
          });
        }

        return m;
      });
    },
  },
  watch: {},
  mounted() {
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
    // console.log("*** this.areas", this.areas);
  },
  methods: {
    /**
     * 传入时间点，计算left值
     * @param timestamp 时间戳
     * @returns {number}
     */
    handle_left(timestamp) {
      let start = moment(
        `${moment().format("YYYY-MM-DD")} ${TIME_SETTING.range[0]}`
      ).unix();

      return Math.floor((timestamp - start) / 60 / TIME_SETTING.interval);
    },
  },
};
</script>

<style lang="less">
#swiper-container {
  width: 100%;
  height: 400px; 
  // height: 100%;
  position: relative;
  padding-top: 120px;
   .time{
     position: absolute;
     width: 96.5%;
     top:50px;
     left:20px
   
   }
   .line-container {
    position: absolute;
    top: calc(78px - 25px);
    width: 1px;
    height: calc(109% - -29px - 5px);
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      font-size: 14px;

      font-weight: bold;
      color: #e30613;
    }
    .line {
      width: 1px;
      height: calc(100% - 14px);
      background-color: #15FFD5;
    }
  }

  .swiper-slide {
    background: transparent;
  }
}
.swiper-container {
  height: calc(~"137%") !important;
  margin-top: -40px;
}
</style>
